module.exports = __webpack_public_path__ + "a9854ab35154706e80bfa9bb9e4986b9.svg";


//////////////////
// WEBPACK FOOTER
// ./images/logo_cabin_scrolled.svg
// module id = 95
// module chunks = 0